import { Routes } from '@angular/router';
import { authGuard } from '../guard/auth.guard';

export const producerEnterpriseRoutes: Routes = [
    {
        path: 'producer-enterprise/profile',
        loadComponent: () =>
            import('../producer-enterprise/producer-enterprise-profiles/producer-enterprise-profiles.component').then(
                (m) => m.ProducerEnterpriseProfilesComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'producer-enterprise/producer-enterprise-profiles-list',
        loadComponent: () =>
            import('../producer-enterprise/producer-enterprise-profiles/producer-enterprise-profiles-list/producer-enterprise-profiles-list.component').then(
                (m) => m.ProducerEnterpriseProfilesListComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'producer-enterprise/quarterly-transactions',
        loadComponent: () =>
            import('../producer-enterprise/producer-enterprise-quarterly-transactions/producer-enterprise-quarterly-transactions.component').then(
                (m) => m.ProducerEnterpriseQuarterlyTransactionsComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'producer-enterprise/quarterly-transaction-form',
        loadComponent: () =>
            import('../producer-enterprise/producer-enterprise-quarterly-transaction-forms/producer-enterprise-quarterly-transaction-forms.component').then(
                (m) => m.ProducerEnterpriseQuarterlyTransactionFormsComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'producer-enterprise/quarterly-transaction-list',
        loadComponent: () =>
            import('../producer-enterprise/producer-enterprise-quarterly-transaction-list/producer-enterprise-quarterly-transaction-list.component').then(
                (m) => m.ProducerEnterpriseQuarterlyTransactionListComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'producer-enterprise/profile/member/fpo-form',
        loadComponent: () =>
            import('../producer-enterprise/member-details/producer-enterprise-fpo-member-form/producer-enterprise-fpo-member-form.component').then(
                (m) => m.ProducerEnterpriseFpoMemberFormComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'producer-enterprise/profile/member',
        loadComponent: () =>
            import('../producer-enterprise/producer-enterprise-member/producer-enterprise-member.component').then(
                (m) => m.ProducerEnterpriseMemberComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'producer-enterprise/legal-compliances',
        loadComponent: () =>
            import('../producer-enterprise/legal-compliances/legal-compliances.component').then(
                (m) => m.LegalCompliancesComponent
            ),
        canActivate: [authGuard]
    }
];
